import { memo, useCallback, useId, useMemo } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";
import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	roomChangeDisable: ForNodeType<boolean>;
	onSetRoomChangeDisable: (input: boolean) => void;

	guide?: string;
	label?: string;
};

export const QuestionPlanRoomChangeDisable = memo(
	({ roomChangeDisable, onSetRoomChangeDisable, guide: _guide, label: _label }: Props) => {
		const uniqueId = useId();

		const onChange = useCallback(
			(input: boolean) => {
				onSetRoomChangeDisable(input);
			},
			[onSetRoomChangeDisable],
		);

		const label = useMemo(() => _label || "１種類の部屋選択のみを許可する", [_label]);
		const checkboxLabel = useMemo(() => _guide || "グループごとに全て同じ部屋の場合のみ予約可能にする", [_guide]);

		const defaultValue = useMemo(() => {
			if (roomChangeDisable.isEdited) {
				return uniqueId;
			}

			return undefined;
		}, [roomChangeDisable.isEdited, uniqueId]);

		return (
			<Accordion type={"single"} collapsible defaultValue={defaultValue}>
				<AccordionItem value={uniqueId}>
					<AccordionTrigger>
						<p>全て同じ部屋の場合のみ予約可能にする設定</p>
					</AccordionTrigger>

					<AccordionContent className="mb-4">
						<FeatureIslandCategoryQuestionForMain
							required={false}
							title={label}
							isEdited={roomChangeDisable.isEdited}
							hasError={Boolean(roomChangeDisable.error)}
							inputChildren={
								<CheckboxField
									value={roomChangeDisable.value}
									label={checkboxLabel}
									handleChange={onChange}
									errorMessage={roomChangeDisable.error}
								/>
							}
						/>
					</AccordionContent>
				</AccordionItem>
			</Accordion>
		);
	},
);

QuestionPlanRoomChangeDisable.displayName = "QuestionPlanRoomChangeDisable";
